import { Logger, BugReporter, BugReporterEnvironment } from '@lifesize/web-clients-core';
import React from 'react';

const version = process.env.REACT_APP_VERSION || '0.0.1';
const stage = getStage();
let bugReporter: BugReporter;

function getStage(): BugReporterEnvironment {
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }
  return process.env.REACT_APP_STAGE as BugReporterEnvironment;
}

async function init() {
  Logger.listenForKeyboardShortcut();
  bugReporter = new BugReporter('e31e110157c55dfd92e90e4780c2a00a', version, stage);
  if (Logger.isEnabled()) {
    await Logger.initialize('yw0xj3/outlook-vmhao', version, true);
  }
}

function getReactErrorBoundary() {
  if (!bugReporter) {
    throw new Error('Module has not been initialized. Run init() first');
  }
  return bugReporter.getReactErrorBoundary(React);
}

export default { init, version, getReactErrorBoundary, stage };
